import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SiteConfigService } from '@shared/shared/services/site-config.service';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { SiteSettingsService } from './site-settings.service';

@Injectable({
  providedIn: 'root',
})
export class CustomMetaService {
  constructor(
    private titleService: Title,
    private meta: Meta,
    private siteSettingsService: SiteSettingsService,
    private siteConfigService: SiteConfigService
  ) {}

  public updateMetaDetails(subtitle: string, limit?: boolean) {
    let content: string = subtitle;

    // Will update meta description and keywords per client and ensure only single spaces exist
    content = subtitle?.replace(/\s\s+/g, ' ');
    if (limit) {
      content = content?.slice(0, 150);
    }

    this.meta.updateTag({ name: 'description', content: content });
  }

  public updateTitle(titlePrefix?: string, titleSuffix = true) {
    this.siteSettingsService
      .fetchSiteSettings()
      .pipe(take(1))
      .subscribe((settings) => {
        let title = '';
        const prefix = titlePrefix || '';
        const clientName = settings.fe_configuration.name;

        title = prefix + `${titleSuffix ? ' - ' + clientName : ''}`;
        this.titleService.setTitle(title);
      });
  }

  public updateCanonicalLink() {
    const newCanonicalUrl = window.location.origin + window.location.pathname;
    const pathName = window.location.pathname;

    // Remove all alternate tags on init to avoid duplicates
    document.querySelectorAll('link[rel="alternate"]').forEach((tag) => tag.remove());

    // Update or add canonical tag
    this.updateOrAddLinkTag('canonical', newCanonicalUrl);

    if (pathName.includes('homepage')) {
      this.updateAlternateTag();
    }
  }

  private updateAlternateTag() {
    combineLatest([this.siteConfigService.siteList, this.siteSettingsService.fetchSiteSettings()])
      .pipe(take(1))
      .subscribe(([siteList, siteSettings]) => {
        const feConfigPath = siteSettings?.fe_configuration?.path;

        siteList.forEach((site) => {
          const country = site.country_code?.toLowerCase();
          const lang = site.language;
          let brandPath = this.siteSettingsService.replaceBrandPath(feConfigPath);
          brandPath = this.siteSettingsService.brandPathOverride(brandPath, country);
          const alternateUrl = window.location.origin + `/product/${brandPath}/homepage/${country}/${lang}`;

          // Update or add alternate tag
          this.updateOrAddLinkTag('alternate', alternateUrl, lang);
        });
      });
  }

  private updateOrAddLinkTag(rel: string, href: string, hreflang?: string) {
    const existingLink = document.querySelector(`link[rel="${rel}"]`);

    if (existingLink && rel !== 'alternate') {
      existingLink.remove();
    }

    const linkTag = document.createElement('link');
    linkTag.rel = rel;
    linkTag.href = href;
    if (hreflang) {
      linkTag.hreflang = hreflang;
    }

    document.head.appendChild(linkTag);
  }
}
